import axios from "axios";
import qs from 'qs';

export default {
  loadReclamations({state, commit, getters}) {
    return new Promise((resolve, reject) => {
      const type = getters.isArchive ? 'archived' : 'active';
      const typeAction = getters.isSupplier ? 'Supplier' : 'Dealers';
      const {
        page,
        per_page,
        query,
        statuses,
        dealer,
        date_to,
        date_from,
      } = state.params;

      const filters = {
        query,
        statuses: getters.filterStatuses,
        dealer,
        date_to,
        date_from,
      };

      axios.get(`${process.env.VUE_APP_API_URL}/api/reclamations/${typeAction.toLowerCase()}/${type}`, {
        params: {
          page,
          per_page,
          filters
        },
        paramsSerializer: params => {
          return qs.stringify(params, { 
            encode: false,
            skipNulls: true 
          });
        },
      })
        .then(res => {
          resolve(res.data);
          if (getters.isArchive) {
            commit(`update${typeAction}Archived`, res.data.data);
          } else {
            commit(`update${typeAction}`, res.data.data);
          }
          
          commit('updatePagination', res.data.pagination);
        }, error => {
          reject(error)
        })
    })
  },

  searchOrder({ commit, getters }, query) {
    const type = getters.isDealers ? 'dealers' : 'supplier/all';

    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/orders/${type}/?page=1&per_page=25&filters[statuses][0]=DRAFT&filters[status_filter]=not_in&filters[query]=${query}`).then(res => {
        resolve(res.data.data);
        commit('updateSearch', res.data.data);
      }, error => {
        reject(error);
      })
    })
  },

  moveArchive({commit}, body) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/reclamations/move-to-archive`, body)
        .then(res => {
          resolve(res.data);
        }, error => {
          reject(error)
        })
    })
  },

  loadReclamation({commit}, uuid) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/reclamations/${uuid}/info`)
        .then(res => {
          resolve(res.data);
          commit('updateReclamation', res.data);
        }, error => {
          reject(error)
        })
    })
  },

  loadStatuses({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/reclamations/statuses`)
        .then(res => {
          resolve(res.data);
          commit('updateStatuses', res.data);
        }, error => {
          reject(error)
        })
    })
  },

  changeReclamation({commit}, { body, uuid }) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/reclamations/${uuid}`, body)
        .then(res => {
          resolve(res.data);
        }, error => {
          reject(error)
        })
    })
  },
}
